/* tslint:disable */
// @ts-nocheck
/* eslint-disable */
/**
 * Rana simulation API
 * Rana simulation API (latest stable version: v3)   Framework release: 3.5.51   Rana simulation core release: 3.7.3   deployed on:  10:12AM (UTC) on September 07, 2026
 *
 * The version of the OpenAPI document: v3
 * Contact: info@nelen-schuurmans.nl
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * * `created` - created
 * * `requested` - requested
 * * `archiving` - archiving
 * * `archiving_failed` - archiving_failed
 * * `archived` - archived
 * @export
 */
export const PostProcessingStatusEnum = {
  CREATED: "created",
  REQUESTED: "requested",
  ARCHIVING: "archiving",
  ARCHIVING_FAILED: "archiving_failed",
  ARCHIVED: "archived",
} as const;
export type PostProcessingStatusEnum =
  (typeof PostProcessingStatusEnum)[keyof typeof PostProcessingStatusEnum];

export function instanceOfPostProcessingStatusEnum(value: any): boolean {
  for (const key in PostProcessingStatusEnum) {
    if (Object.prototype.hasOwnProperty.call(PostProcessingStatusEnum, key)) {
      if (PostProcessingStatusEnum[key as keyof typeof PostProcessingStatusEnum] === value) {
        return true;
      }
    }
  }
  return false;
}

export function PostProcessingStatusEnumFromJSON(json: any): PostProcessingStatusEnum {
  return PostProcessingStatusEnumFromJSONTyped(json, false);
}

export function PostProcessingStatusEnumFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): PostProcessingStatusEnum {
  return json as PostProcessingStatusEnum;
}

export function PostProcessingStatusEnumToJSON(value?: PostProcessingStatusEnum | null): any {
  return value as any;
}

export function PostProcessingStatusEnumToJSONTyped(
  value: any,
  ignoreDiscriminator: boolean
): PostProcessingStatusEnum {
  return value as PostProcessingStatusEnum;
}
